import { z } from 'zod';
import { FORM_VALIDATION } from '../constants/auth';

export const emailSchema = z.object({
  email: z.string().email({ message: 'Please enter a valid email address' }),
});

export const codeSchema = z.object({
  code: z.string().min(FORM_VALIDATION.CODE_MIN_LENGTH, {
    message: 'Please enter a valid code',
  }),
});
